module.exports = __webpack_public_path__ + "static/media/usa-anli8.80437b99.jpg";